import { Controller } from 'stimulus'
import Cookies from 'js-cookie'
export default class extends Controller {
  static targets = ['sidebar']
  static values = {
    'ymId': Number
  }

  connect() {
    this.activeClass = 'active'
    this.themeClass = 'theme-dark'
    this.overflowClass = 'overflow-hidden'
    this.element.classList.remove('invisible')
    this.header = document.querySelector('header')
  }

  openSidebar(e) {
    this.sidebarTarget.sidebar.open(e)
  }

  openModal(e) {
    const data = e.currentTarget.dataset
    const el = document.getElementById(data.target)
    if (el) { el.modal.open(e, data.param) }
  }

  closeElement(e) {
    const data = e.currentTarget.dataset
    const el = document.getElementById(data.closeTarget)
    if(el) { el.classList.add(data.hiddenClass || 'hidden') }
  }

  scrollTo(e) {
    e.preventDefault()
    const href = e.currentTarget.getAttribute('href')
    const target = document.querySelector(href)

    if (target) {
      window.scroll(0, target.offsetTop - this.header.offsetHeight)
    }
  }

  calltouch(e) {
    e.preventDefault();
    try {
      window.ct('modules', 'widgets', 'openExternal', 'callback');
    } catch(e) {
      console.log('calltouch not working');
    }
  }

  lock() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.paddingRight = `${scrollbarWidth}px`
    document.body.classList.add(this.overflowClass)

    if (this.headerTarget.classList.contains('fixed')) {
      this.headerTarget.style.right = `${scrollbarWidth}px`
    }
  }

  unlock() {
    document.body.style.paddingRight = null;
    document.body.classList.remove(this.overflowClass);
    if (this.headerTarget.classList.contains('fixed')) {
      this.headerTarget.style.removeProperty('right')
    }
  }

  reachGoal(e) {
    const target = e.currentTarget
    if (!window.ym || !target.dataset.ymGoals) { return }
    
    let timerId = null
    if (target.hasAttribute('href') && (target.href !== '#calltouch')) {
      e.preventDefault()
      // Если обработчик на ссылке, то совершаем переход через коллбэк
      // события метрики, чтобы оно точно успело сработать
      // Подстраховка через секунду на случай, если не сработало событие
      timerId = setTimeout(() => { window.location.href = target.href }, 1000)
    }
    const ymGoals = JSON.parse(target.dataset.ymGoals)
    ymGoals.forEach((goal, index, goals) => {
      // Вешаем коллбэк перехода на последнее событие, если их несколько
      if (timerId && index === goals.length - 1) {
        window.ym(goal.counterId || this.ymIdValue, 'reachGoal', goal.name, goal.params, () => {
          window.clearTimeout(timerId)
          window.location.href = target.href
        })
      } else {
        window.ym(goal.counterId || this.ymIdValue, 'reachGoal', goal.name, goal.params)
      }
    })
  }

  setCookie(e) {
    console.log(e)
    const data = e.target.dataset
    const domain = data.cookieDomains ? "domain=" + window.location.hostname.replace(/^[^.]+\./g, ".") + ";" : ""
    let expires = ""
    if (data.cookieDays) {
      const date = new Date()
      date.setTime(date.getTime() + (data.cookieDays * 24 * 60 * 60 * 1000))
      expires = "expires=" + date.toUTCString() + ";"
    }
    document.cookie = `${data.cookieName}=${data.cookieValue || ""};${expires}${domain}path=/;`
  }
}
